import { FC, PropsWithChildren } from 'react';
import { CatList } from '@blocks-react/components/List';

export const HeaderSearchBarSuggestionList: FC<PropsWithChildren> = ({
  children,
}) => <CatList>{children}</CatList>;
